import styled from "styled-components";

export const TrajesContainer = styled.header`
    height: 100vh;
    background-image: url("/img/Trajes-pc.jpg");
    background-size: cover;
    background-position: center right;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    padding: 0 8%;
    align-items: center;
    justify-content: center;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1;
    }

    p {
        font-size: 50px;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;

        color: transparent;
        -webkit-text-stroke: 1px #fff;

        letter-spacing: 4px;
        z-index: 2;
    }

    @media (max-width: 1024px) {
        background-position: center;
    }

    @media (max-width: 768px) {
        height: 90vh;
        background-position: center top;
        background-image: url("/img/Trajes-movil.jpg");
        padding: 0 5%;
    }
`;

export const ButtonContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 20px;
    background: #b5b09b;
    padding: 50px 20px 20px 20px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        justify-items: center;
    }
`;

export const TrajeBase = styled.button`
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 15px;
    cursor: pointer;
    transition: all 0.3s ease;

    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    font-size: 1.1rem;;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1.5px;

    padding: 20px;

    &:hover {
        transform: translateY(-5px) scale(1.02);
        box-shadow: 0 12px 25px rgba(0,0,0,0.3);
    }

    &:active {
        transform: scale(0.98);
        box-shadow: none;
    }

    @media (max-width: 768px) {
        max-width: 250px;
    }
`;

export const TrajesNegros = styled(TrajeBase)`
    background: #111;
    color: #cecece;
    border: 2px solid #fff;

    &:hover {
        background: #F5F5F5;
        color: #111;
        border: 2px solid #111;
    }
`;

export const TrajesAzules = styled(TrajeBase)`
    background: #004da5;
    color: #ffffff;
    border: 2px solid #000;

    &:hover {
        background: #f77f00;
        color: #161616;
    }
`;

export const TrajesGrises = styled(TrajeBase)`
    background: #979797;
    color: #282828;
    border: 2px solid #282828;

    &:hover {
        background: #BFBFBF;
        color: #111;
        border: 2px solid #111;
    }
`;

export const TrajesTintos = styled(TrajeBase)`
    background: #620808;
    color: #cacaca;
    border: 2px solid #cacaca;

    &:hover {
        background: #3AAFA9;
        color: #111;
        border: 2px solid #111;
    }
`;

export const TrajesColores = styled(TrajeBase)`
    background: #938a4d;
    color: #000000;
    border: 2px solid #000000;

    &:hover {
        background: #5862A7;
        color: #d7d7d7;
        border: 2px solid #d7d7d7;
    }
`;